/* eslint-disable @typescript-eslint/no-explicit-any */

import type {AxiosInstance} from 'axios';
import type {OpenAPIConfig} from './core/OpenAPI';

import type {ApiRequestOptions} from './core/ApiRequestOptions';
import {BaseHttpRequest} from './core/BaseHttpRequest';
import {CancelablePromise} from './core/CancelablePromise';
import {request} from './core/request';
import type {AdditionalApiOptions} from './withOptions';

export function getHttpRequestWithOwnInstance(
  axiosInstance: AxiosInstance,
  additionalOptions?: AdditionalApiOptions,
): any {
  return class AxiosHttpRequestInjector extends BaseHttpRequest {
    constructor(config: OpenAPIConfig) {
      super(config);
    }

    public override request<T>(
      options: ApiRequestOptions,
    ): CancelablePromise<T> {
      const mergedOptions = {...options, ...(additionalOptions || {})};

      if (!additionalOptions?.baseUrl) {
        return request<T>(this.config, mergedOptions, axiosInstance);
      }

      // Late-bind the runtime base URL before the generated request() builds
      // the URL synchronously from config.BASE. Wrapped in CancelablePromise
      // to honor the BaseHttpRequest contract and preserve cancellation.
      return new CancelablePromise<T>(async (resolve, reject, onCancel) => {
        this.config.BASE = await additionalOptions.baseUrl!();
        const inner = request<T>(this.config, mergedOptions, axiosInstance);
        onCancel(() => inner.cancel());
        inner.then(resolve, reject);
      });
    }
  };
}
